module.exports = __webpack_public_path__ + "img/fcs.1916028e.svg";